export const CancelReason = [
    {
        dispStr: 'Delay in estimated delivery',
        exclusive: false, toggleView: false, value: 1
    },
    {
        dispStr: 'No longer needed',
        exclusive: false, toggleView: false, value: 2
    },
    {
        dispStr: 'Placed a duplicate order',
        exclusive: false, toggleView: false, value: 5
    },
    {
        dispStr: 'No response from the chemist store',
        exclusive: false, toggleView: false, value: 6
    },
    {
        dispStr: 'Other',
        exclusive: false, toggleView: true, value: 4
    },
]

export const PositiveReviews = [
    {
        dispStr: 'Polite Behavior',
        exclusive: false, value: 'Polite Behavior'
    },
    {
        dispStr: 'Quick Response',
        exclusive: false, value: 'Quick Response'
    },
    {
        dispStr: 'Value for money',
        exclusive: false, value: 'Value for money'
    },
    {
        dispStr: 'On Time Delivery',
        exclusive: false, value: 'On Time Delivery'
    },
]
export const NegativeReviews = [
    {
        dispStr: 'Impolite Behavior',
        exclusive: false, value: 'Impolite Behavior'
    },
    {
        dispStr: 'Delayed Response',
        exclusive: false, value: 'Delayed Response'
    },
    {
        dispStr: 'No Response',
        exclusive: false, value: 'No Response'
    },
    {
        dispStr: 'Late Delivery',
        exclusive: false, value: 'Late Delivery'
    },
]

export const ReviewLabel = [
    { dispStr: 'BAD!', value: 1 },
    { dispStr: 'OKAY!', value: 2 },
    { dispStr: 'GOOD!', value: 3 },
    { dispStr: 'LOVED IT!', value: 4 },
    { dispStr: 'SUPERB!', value: 5 },
]

export const consultationPaymentSurveyList = [
    {
        dispStr: 'I thought it was free', exclusive: false,
        value: 'I thought it was free'
    },
    {
        dispStr: 'I don\'t know how to pay online', exclusive: false,
        value: 'I don\'t know how to pay online'
    },
    {
        dispStr: 'Just testing or trying', exclusive: false,
        value: 'Just testing or trying'
    }
]

export const aayuCardPaymentbackSurveyList = [
    {
        dispStr: 'Cannot pay online', exclusive: false,
        value: 'Cannot pay online'
    },
    {
        dispStr: 'Not suitable for my needs', exclusive: false,
        value: 'Not suitable for my needs'
    },
    {
        dispStr: 'Need only for some specific problem', exclusive: false,
        value: 'Need only for some specific problem'
    },
    {
        dispStr: 'Did not understand', exclusive: false,
        value: 'Did not understand'
    }
]